import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getAveragePerformanceData = store => store[NAME].averagePerformanceData;
export const getAveragePotentialData = store => store[NAME].averagePotentialData;
export const getDetailData = store => store[NAME].detailData;